import React, { Component } from 'react';
import { Trans } from '@lingui/react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import forEach from 'lodash/forEach';
import css from './index.scss';

class SignInCardsFormats extends Component {
    constructor(props) {
        super(props);
        this.state = {
            format: 'QR_3X3'
        };
    }

    signInCardsFormat = [{
        id: 'QR_3X3',
        name: <Trans>QR codes 3x3</Trans>,
        isDefault: true
    },
    {
        id: 'QR',
        name: <Trans>QR codes 2x2</Trans>,
        isDefault: false
    },
    {
        id: '_2X5',
        name: <Trans>2x5 label</Trans>,
        isDefault: false
    },
    {
        id: '_2X7',
        name: <Trans>2x7 label</Trans>,
        isDefault: false
    },
    {
        id: '_3X8',
        name: <Trans>3x8 label</Trans>,
        isDefault: false
    }
    ];

    onFormatSelection = (element) => {
        const formatId = element.target.id;
        forEach(this.signInCardsFormat, (item) => {
            if (item.id === formatId) {
                item.isDefault = true;
            } else {
                item.isDefault = false;
            }
        });

        this.setState({ format: formatId });
    }

    download = () => {
        this.props.handleOnDownloadSignInCards(this.state.format);
    }

    renderRadioButtons = () => this.signInCardsFormat.map(val => (<div className={css.formatContainer} key={val.id}>
        <div className={css.radioButton}><input
            checked={val.isDefault}
            className={css.group}
            id={val.id}
            name="format"
            onChange={this.onFormatSelection}
            type="radio"
            value={val.id}
        /><label htmlFor={val.id} /></div>
        <div className={css.formatName}> {val.name} </div>
    </div>));

    render() {
        return (<div className={css.modalContent}>
            <div className={css.modalHeader}>
                <div className={css.modalHeaderText}><Trans>Please select format for sign in cards</Trans></div>
                <div className={css.close} onClick={this.props.handleOnCancel} role="button" tabIndex={0}>&times;</div>
            </div>
            <div className={css.modalBody}>
                <div className={css.radio}>
                    {this.renderRadioButtons()}
                </div>
            </div>
            <div className={css.modalFooter}>
                <div className={css.buttonContainer}>
                    <button
                        className="btn btn--primary btn--small blue"
                        onClick={() => this.download()}
                    >
                        <div>
                            <div><span><Trans>Download</Trans></span></div>
                        </div>
                    </button>
                </div>
            </div>
        </div>);
    }
}

SignInCardsFormats.propTypes = {
    handleOnCancel: PropTypes.func,
    handleOnDownloadSignInCards: PropTypes.func
};

export default (styleable(css)(SignInCardsFormats));



// WEBPACK FOOTER //
// ./components/sign-in-cards-formats/index.js